// @flow
import React from 'react';
import cx from 'classnames';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import './CategorySupplierItem.scss';
import { escapeForUrl } from '../../../lib/common';

type Props = {
  supplier: string,
};

const CategorySupplierItem = ({ category, supplier, count, location }: Props) => {
  const active = supplier === queryString.parse(location.search).supplier || '';
  return (
    <Link
      className={cx('CategorySupplierItem', { active })}
      to={`/categories/${escapeForUrl(category)}?supplier=${supplier}`}
    >
      <div className="name">{supplier}</div>
      <div className="counts">{count}</div>
    </Link>
  );
};

export default CategorySupplierItem;



// WEBPACK FOOTER //
// ./src/components/categories/CategorySupplierItem/CategorySupplierItem.js